import { render, staticRenderFns } from "./CarSatety.vue?vue&type=template&id=32577bf2&scoped=true"
import script from "./CarSatety.vue?vue&type=script&lang=js"
export * from "./CarSatety.vue?vue&type=script&lang=js"
import style0 from "./CarSatety.vue?vue&type=style&index=0&id=32577bf2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32577bf2",
  null
  
)

export default component.exports